
import Api from "config/Api"
import axios from 'axios'
import JWTaxios from 'utils/JWT'

export async function loginPass(json) {
  return await axios.post(Api.Login,json, {headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' }}).then(res => res.data);
}

export async function refreshJWT(refreshToken) {
  return await JWTaxios.post(Api.RefreshJWT,{refreshToken:refreshToken},{headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' }}).then(res => res.data);
}

export default loginPass